import type { EdgeData, NodeId } from '@ipfabric/utils';

export const isEdgeConnectedToNode =
  (nodeId: NodeId) =>
  (edgeData: EdgeData): boolean =>
    edgeData.source === nodeId || edgeData.target === nodeId;
